module.exports = __webpack_public_path__ + "static/media/Success.3b3301ee.svg";